import styled, { css } from 'styled-components';
import statusMapIcon_gas_blue from 'static/images/icon/statusMapIcon_gas_blue.png';

export const ModuleEditablePopupContainer = styled.div`
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModuleEditable = styled.div`
  width: 350px;
  height: 650px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  text-align: center;
  border-radius: 10px;
  background: rgb(39, 47, 60);

  & > form {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    & > div {
      position: relative;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 5px 0px;

      & > select:disabled {
        background: #333;
      }

      & > p {
        margin-bottom: 0.3rem;
        width: 100px;
        text-align: left;
      }

      & > input,
      & > select {
        width: 180px;
        font-size: 13px;
      }

      & > input:read-only {
        background-color: #969696;
        border: 0px;
        cursor: initial;
      }

      & > input.calendar-input {
        cursor: pointer;
      }

      & > button {
        color: #fff;
      }

      & > button.calendarInit {
        font-size: 12px;
        background-color: #3d4a5c;
        border-width: 0px;
        padding: 0rem 0.4rem;
        height: 21px;
      }

      & > button.submitBtn {
        font-size: 14px;
        background-color: #3d4a5c;
        border-width: 0px;
        padding: 0.4rem 2.4rem;
      }
    }
  }
  & > div:last-child {
    justify-content: center;
  }
`;

export const ModuleAreaSelectMap = styled.div`
  background: rgb(39, 47, 60);
  position: relative;
  width: 730px;
  height: 450px;
  & > img {
    width: 730px;
    height: 450px;
  }
`;

export const MapIconContainer = styled.div`
  width: 50px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  ${(props) =>
    css`
      left: ${props.xAxis - 25}px;
      top: ${props.yAxis - 30}px;
    `}
  img {
    width: 100%;
    height: 100%;
    content: url(${statusMapIcon_gas_blue});
  }
`;
